import { isValidPhoneNumber } from 'libphonenumber-js'
import { i18n } from '@/localization.vue'

const required = {
  required: true,
  trigger: 'change',
  validator: (rule, value, callback) => {
    if (
      value === undefined ||
      value === null ||
      (typeof value === 'string' && value.trim() === '')
    ) {
      callback(new Error(i18n.t('msg.validator.error.required')))
    } else {
      callback()
    }
  },
}

const phone = {
  trigger: 'change',
  validator: (rule, value, callback) => {
    if (value && !isValidPhoneNumber(value, 'AR')) {
      callback(new Error(i18n.t('msg.validator.error.invalidPhone')))
    } else {
      callback()
    }
  },
}

const address = {
  type: 'Object',
  trigger: 'change',
  validator: (rule, value, callback) => {
    if (!value) {
      callback(new Error(i18n.t('msg.validator.error.requiredAddress')))
    } else if (!value.lat || !value.lng) {
      callback(new Error(i18n.t('msg.validator.error.incompleteAddress')))
    } else {
      callback()
    }
  },
}

const email = {
  trigger: 'change',
  validator: (rule, value, callback) => {
    if (value && !isValidEmail(value)) {
      callback(new Error(i18n.t('msg.validator.error.invalidEmail')))
    } else {
      callback()
    }
  },
}

const number = {
  trigger: 'change',
  validator: (rule, value, callback) => {
    if (value && isNaN(value)) {
      callback(new Error(i18n.t('msg.validator.error.invalidNumber')))
    } else {
      callback()
    }
  },
}

const url = {
  trigger: 'change',
  validator: (rule, value, callback) => {
    try {
      const url = new URL(value)
      callback()
      return url
    } catch (err) {
      callback(new Error(i18n.t('msg.validator.error.invalidUrl')))
    }
  },
}

const money = {
  trigger: 'change',
  validator: (rule, value, callback) => {
    if (value && !/^\d+$/.test(value)) {
      callback(new Error(i18n.t('msg.validator.error.invalidAmount')))
    } else {
      callback()
    }
  },
}

const name = {
  trigger: 'change',
  validator: (rule, value, callback) => {
    if (value && !/^[\w\s]{1,20}$/.test(value)) {
      callback(new Error(i18n.t('msg.validator.error.invalidName')))
    } else {
      callback()
    }
  },
}

const ref = {
  trigger: 'change',
  validator: (rule, value, callback) => {
    if (value.length > 16) {
      callback(new Error(i18n.t('msg.validator.error.invalidCodeLength')))
    } else if (!/^[a-zA-Z0-9_-]{1,16}$/.test(value)) {
      callback(new Error(i18n.t('msg.validator.error.invalidCodeCharacters')))
    } else {
      callback()
    }
  },
}

const isValidEmail = (email) => {
  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return re.test(String(email).toLowerCase())
}

export default {
  required,
  email,
  phone,
  address,
  number,
  name,
  money,
  ref,
  url,
}
